import React from "react";
import {withTextStyle} from "@components/Booking/LocationSelection/LocationRow/styles";
import {WithDistance} from "@components/Booking/LocationSelection/useWithDistanceFromUser";
import {Location} from "@components/Booking/LocationSelection/types";
import {distToText} from "../../../../../../../../utils/distToText";
import {useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";

const LocationName = ({
  disabled,
  location,
}: {
  disabled: boolean;
  location: WithDistance<Pick<Location, "name">>;
}) => {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  const {distance, name} = location;
  const locationNameClass = withTextStyle(
    "font-i text-base leading-4 sm:text-xl font-medium",
    "text-gray-1000",
    disabled,
  );
  const milesAwayClass = withTextStyle("font-i text-sm", "text-gray-900", disabled);
  const distanceText = distToText(i18n.t, distance, "web-scheduling");

  // The UI looks janky if the clinic name runs right up to the end of the line, such that
  // the "· 81 mi" appears on the next. Splitting the name like this ensures that the last
  // word from the clinic name appears on the same line as the distance, if wrapping is necessary.
  const lastWhitespace = name?.lastIndexOf(" ");
  const normalWrapName = lastWhitespace ? name?.substring(0, lastWhitespace) : name;
  const lastNamePart = lastWhitespace ? name?.substring(lastWhitespace) : undefined;

  return (
    <p>
      <span className={locationNameClass}>{normalWrapName}</span>
      {(lastNamePart || distance) && (
        <span className="whitespace-nowrap">
          {lastNamePart && <span className={locationNameClass}> {lastNamePart}</span>}
          {distance && (
            <span className={milesAwayClass}>
              <span> · </span>
              <span>{distanceText}</span>
            </span>
          )}
        </span>
      )}
    </p>
  );
};

export default React.memo(LocationName);
